module.exports = __webpack_public_path__ + "static/food-tile-d28508a13b346af909f6d5a252e4d77d.jpg";